// src/components/ScrollToTop.js
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const location = useLocation();

  useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    requestAnimationFrame(() => {
      // Window + document
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      // App containers
      const shell = document.querySelector(".app-shell");
      const card = document.querySelector(".app-card");
      const main = document.querySelector(".app-main");

      shell && (shell.scrollTop = 0);
      card && (card.scrollTop = 0);
      main && (main.scrollTop = 0);
    });
  }, [location.pathname, location.state]);

  return null;
}
